import React from 'react';
import { getToken } from '../../lib/authStore';

const API = process.env.REACT_APP_BACKEND_URL;

// Small lender-logo tile — 44×44 square, rounded, falls back to first-letter
// initials on a warm neutral chip so cards without an uploaded logo still
// read cleanly in the grid.
export default function LenderLogo({ lender, size = 44 }) {
  const token = getToken();
  const url = lender?.logoPath && token
    ? `${API}/api/lenders/${lender.id}/logo?auth=${encodeURIComponent(token)}`
    : null;
  const letter = (lender?.name || '?').trim()[0]?.toUpperCase() || '?';
  return (
    <div
      className="shrink-0 rounded-lg border hairline bg-neutral-50 flex items-center justify-center overflow-hidden"
      style={{ height: size, width: size }}
    >
      {url ? (
        <img
          src={url}
          alt=""
          className="max-h-full max-w-full object-contain"
          onError={(e) => { e.currentTarget.style.display = 'none'; }}
        />
      ) : (
        <span className="text-[15px] font-bold text-neutral-500">{letter}</span>
      )}
    </div>
  );
}
